import { format } from 'date-fns';
import localeEn from 'date-fns/locale/en-US';
import localeEs from 'date-fns/locale/es';
import localePt from 'date-fns/locale/pt-BR';
import i18next from 'i18next';
import { DAY_MONTH_FORMAT, IN_FULL_FORMAT, DAY_MONTH_YEART_FORMAT } from '_/space-management/config/date';
import { languages } from '_/space-management/constants/languages';

const locales: Record<string, any> = {
  'en-US': localeEn,
  es: localeEs,
  'pt-BR': localePt,
  en: localeEn,
  pt: localePt,
};

export function formatDate(
  d: Date | number,
  f: string,
  o?:
    | {
        locale?: globalThis.Locale | undefined;
        weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | undefined;
        firstWeekContainsDate?: number | undefined;
        useAdditionalWeekYearTokens?: boolean | undefined;
        useAdditionalDayOfYearTokens?: boolean | undefined;
      }
    | undefined
): string {
  try {
    const currentLanguageCode = i18next.language || 'en';
    
    const lowerLang = currentLanguageCode.toLowerCase();
    let normalizedCode = 'en';
    if (lowerLang.includes('pt')) normalizedCode = 'pt-BR';
    else if (lowerLang.includes('es')) normalizedCode = 'es';

    const currentLocale = locales[normalizedCode] || localeEn;
    
    const langMapping = languages.find(
      (l) => l.code === normalizedCode
    ) || languages.find((l) => l.code === 'en') || languages[0];

    let resolvedFormat = f;
    if (f === DAY_MONTH_FORMAT) resolvedFormat = langMapping.format.day_month;
    else if (f === IN_FULL_FORMAT) resolvedFormat = langMapping.format.full_date;
    else if (f === DAY_MONTH_YEART_FORMAT) resolvedFormat = langMapping.format.full_date_short;

    return format(d, resolvedFormat, { locale: currentLocale, ...o });
  } catch (_) {
    return '';
  }
}
